import { styled } from '@mui/system';

export const ForgotSuccessContainer = styled('div')({
  background: 'var(--new-peony-50)',
  display: 'flex',
  justifyContent: 'center',
  minHeight: '100vh',
});

export const ForgotSuccessWrapper = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  maxWidth: '744px',
  width: '100%',
  margin: '57px 0',
  background: 'var(--new-neutral-tertiary)',
  '@media (max-width:744px)': {
    margin: 0,
  },
  '.forgot-success-section': {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    flexWrap: 'wrap',
  },
  '.success-container': {
    display: 'flex',
    justifyContent: 'center',
    '.success-wrapper': {
      maxWidth: '384px',
      '.img-container': {
        display: 'flex',
        justifyContent: 'center',
        paddingBottom: '8px',
        '@media only screen and (max-width: 480px)': {
          paddingBottom: 0,
        },
        img: {
          width: '123px',
          height: '123px',
          '@media only screen and (max-width: 480px)': {
            width: '88px',
            height: '88px',
          },
        },
      },
      '.forgot-success-header': {
        textAlign: 'center',
        color: 'var(--new-navy)',
        fontFamily: 'var(--new-font)',
        fontStyle: 'normal',
        fontWeight: 300,
        fontSize: '32px',
        '@media only screen and (max-width: 480px)': {
          paddingBottom: '12px',
        },
      },
      '.forgot-success-title': {
        textAlign: 'center',
        color: 'var(--new-navy)',
        fontFamily: 'var(--new-font)',
        fontStyle: 'normal',
        fontWeight: 300,
      },
    },
  },
  '.header': {
    textAlign: 'center',
    color: 'var(--neutral-primary)',
    paddingBottom: '8px',
    paddingTop: '24px',
    maxWidth: '384px',
  },
  '.title': {
    textAlign: 'center',
    color: 'var(--neutral-primary)',
    paddingBottom: '40px',
    maxWidth: '384px',
  },
});
